import React, { useState, useEffect } from "react";
import { IconButton, Menu, MenuItem, Typography, Badge, Divider } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import api_client from "../../Authentication/axiosConfig";

const SourceFilterMenu = ({ filters, setFilters, fetchData }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [sources, setSources] = useState([]);
    const isActive = !!filters.source;
    
    useEffect(() => {
        // Fetch distinct sources
        const fetchSources = async () => {
            try {
                const sourcesResponse = await api_client.get("/list_news/", { params: { page: 1, page_size: 1000 } });
                
                if (sourcesResponse.data && sourcesResponse.data.results) {
                    const allSources = sourcesResponse.data.results.map(item => item.source);
                    
                    // Get unique sources
                    setSources([...new Set(allSources)].filter(Boolean).sort());
                }
            } catch (error) {
                console.error("Error fetching sources:", error);
            }
        };
        
        fetchSources();
    }, []);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleSourceFilter = (source) => {
        const newFilters = { ...filters, source };
        setFilters(newFilters);
        handleMenuClose();
        fetchData(newFilters);
    };
    
    const clearSourceFilter = () => {
        const { source, ...restFilters } = filters;
        setFilters(restFilters);
        handleMenuClose();
        fetchData(restFilters);
    };
    
    return (
        <div>
            <Badge 
                color="primary" 
                variant="dot" 
                invisible={!isActive}
                overlap="circular"
            >
                <IconButton 
                    onClick={handleMenuClick} 
                    color={isActive ? "primary" : "default"}
                    title="Filter by source"
                >
                    <FilterAltIcon />
                </IconButton>
            </Badge>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                PaperProps={{
                    style: {
                        borderRadius: "8px",
                        marginTop: "8px",
                        maxHeight: "450px",
                        width: "240px",
                    },
                }}
            >
                <Typography variant="subtitle1" sx={{ px: 2, py: 1, fontWeight: 'bold' }}>
                    Sources
                </Typography>
                
                {isActive && (
                    <Typography variant="body2" sx={{ px: 2, pb: 1, fontSize: '0.8rem', color: 'primary.main' }}>
                        Active: {filters.source}
                    </Typography>
                )}
                
                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    {sources.map(source => (
                        <MenuItem 
                            key={source} 
                            onClick={() => handleSourceFilter(source)}
                            className="px-3 py-2"
                            selected={filters.source === source}
                        >
                            {source}
                        </MenuItem>
                    ))}
                </div>
                
                <Divider sx={{ my: 1 }} />
                
                <MenuItem 
                    onClick={clearSourceFilter}
                    className="px-3 py-2"
                    disabled={!isActive}
                >
                    <Typography color={isActive ? "error" : "text.disabled"}>
                        {isActive ? "Clear Source Filter" : "No Source Filter Applied"}
                    </Typography>
                </MenuItem>
            </Menu>
        </div>
    );
};

export default SourceFilterMenu;
